export const DEFAULT_STARS_COUNT = 0;

export type TCommentTarget = {
    comment: { value: string }
};

/** Ключ сохранения в localStorage */
export const STORAGE_RATE_KEY = 'storage_rate_key';